import { render, staticRenderFns } from "./img-list-for-quiz.html?vue&type=template&id=32096bd6&scoped=true&"
import script from "./img-list-for-quiz.js?vue&type=script&lang=js&"
export * from "./img-list-for-quiz.js?vue&type=script&lang=js&"
import style0 from "./img-list-for-quiz.scss?vue&type=style&index=0&id=32096bd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32096bd6",
  null
  
)

export default component.exports